import { AbstractControl, ValidationErrors } from '@angular/forms';

// Luhn-algoritmen för att validera personnummer
export function isValidPersonnummer(control: AbstractControl): ValidationErrors | null {
  const shortNumber = control.value.substring(2);
  const digits = shortNumber.split('').map(Number);
  let sum = 0;

  digits.forEach((digit: number, index: number) => {
    let value = digit;

    if (index % 2 === 0) {
      value *= 2;

      if (value > 9) {
        value -= 9;
      }
    }

    sum += value;
  });

  const forbidden = sum % 10 !== 0;

  return forbidden ? { invalidPersonnummer: 'Ogiltigt personnummer' } : null;
}
